export default "__VITE_ASSET__b9dd8105__"